import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const emergencyCallsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "emergency-calls",
}).lazy(() => import("./index.lazy").then((d) => d.Route));
